(function(){
  let question_index=0
  const answer_data = {q0:[5]}
  const question_data = [
    {
      id:1,
      question:"How likely are you to recommend OGL to a friend or colleague?",
      option:[
        {value:0, type:"select", label:"0"},
        {value:1, type:"select", label:"1"},
        {value:2, type:"select", label:"2"},
        {value:3, type:"select", label:"3"},
        {value:4, type:"select", label:"4"},
        {value:5, type:"select", label:"5"},
        {value:6, type:"select", label:"6"},
        {value:7, type:"select", label:"7"},
        {value:8, type:"select", label:"8"},
        {value:9, type:"select", label:"9"},
        {value:10, type:"select", label:"10"},
      ],
      request:true,
      multiple:false
    },
    {
      id:2,
      question:"what's the main reason for your score?",
      option:[
        {value:0, type:"select", label:"Products quality"},
        {value:1, type:"select", label:"Products design"},
        {value:2, type:"select", label:"Products pricing"},
        {value:3, type:"select", label:"Products delivery"},
        {value:4, type:"select", label:"Return Policy"},
        {value:5, type:"select", label:"Customer support"},

        {value:6, type:"select", label:"The products fit perfectly"},
        {value:7, type:"select", label:"Beautiful design/color of products"},
        {value:8, type:"select", label:"Good price"},
        {value:9, type:"select", label:"Rapid shipping"},
        {value:10, type:"select", label:"Smooth client service"},
        {value:11, type:"select", label:"Eco-friendly"},
        {value:12, type:"select", label:"Good online shopping experience"},
        {value:13, type:"select", label:"Beautiful website layout"},
        
        {value:"", type:'text', label:"Others..."},

      ],
      request:true,
      multiple:true
    },
    {
      id:3,
      question:"How well does our product match the online photos?",
      option:[
        {value: 4, type: "select", label: "Very satisfied"},
        {value: 3, type: "select", label: "Satisfied "},
        {value: 2, type: "select", label: "Neutral"},
        {value: 1, type: "select", label: "unsatisfied"},
        {value: 0, type: "select", label: "Very unsatisfied"},
      ],
      request:true,
      multiple:false
    },
    {
      id:4,
      question:"Are you satisfied with the product quality?",
      option:[
        {value: 4, type: "select", label: "Very satisfied"},
        {value: 3, type: "select", label: "Satisfied "},
        {value: 2, type: "select", label: "Neutral"},
        {value: 1, type: "select", label: "unsatisfied"},
        {value: 0, type: "select", label: "Very unsatisfied"},
      ],
      request:true,
      multiple:false
    },
    {
      id:5,
      question:"Are you satisfied with the size and fit of our product?",
      option:[
        // {value: 4, type: "select", label: "Very satisfied"},
        // {value: 3, type: "select", label: "Satisfied "},
        // {value: 2, type: "select", label: "Neutral"},
        // {value: 1, type: "select", label: "unsatisfied"},
        // {value: 0, type: "select", label: "Very unsatisfied"},
        {value: 0, type: "select", label: "true to size"},
        {value: 1, type: "select", label: "sizes run large"},
        {value: 2, type: "select", label: "sizes run small"},
        {id:"height", value:"", type:'text', label:"Your height"},
        {id:"weight", value:"", type:'text', label:"Your weight"},
        {id:"size", value:"", type:'text', label:"The size you have worn in other brands"},
      ],
      request:true,
      multiple:false
    },
    {
      id:6,
      question:"Are you satisfied with the processing time and delivery time of the order?",
      option:[
        {value: 4, type: "select", label: "Very satisfied"},
        {value: 3, type: "select", label: "Satisfied "},
        {value: 2, type: "select", label: "Neutral"},
        {value: 1, type: "select", label: "unsatisfied"},
        {value: 0, type: "select", label: "Very unsatisfied"},
      ],
      request:true,
      multiple:false
    },
    {
      id:7,
      question:"Are you satisfied with the transparency of the delivery process?",
      option:[
        {value: 4, type: "select", label: "Very satisfied"},
        {value: 3, type: "select", label: "Satisfied "},
        {value: 2, type: "select", label: "Neutral"},
        {value: 1, type: "select", label: "unsatisfied"},
        {value: 0, type: "select", label: "Very unsatisfied"},
      ],
      request:true,
      multiple:false
    },
    {
      id:8,
      question:"OGL made my problem-solving process easier?",
      option:[
        {value: 6, type: "select", label: "Strongly agree"},
        {value: 5, type: "select", label: "Agree"},
        {value: 4, type: "select", label: "Somewhat agree"},
        {value: 3, type: "select", label: "Neutral"},
        {value: 2, type: "select", label: "Somewhat disagree"},
        {value: 1, type: "select", label: "Disagree"},
        {value: 0, type: "select", label: "Strongly disagree"},
      ],
      request:true,
      multiple:false
    },
    {
      id:9,
      question:"Are you satisfied with the brand communication between our CS team?",
      option:[
        {value: 4, type: "select", label: "Very satisfied"},
        {value: 3, type: "select", label: "Satisfied "},
        {value: 2, type: "select", label: "Neutral"},
        {value: 1, type: "select", label: "unsatisfied"},
        {value: 0, type: "select", label: "Very unsatisfied"},
      ],
      request:true,
      multiple:false
    },
    {
      id:10,
      question:"Any other comments/suggestions/ideas?",
      option:[
        {value:"", type:'text', label:"Please input something!"},
      ],
      request:false,
      multiple:false
    },
    {
      id:11,
      question:"You've got a chance to win our exclusive quarterly ambassador gift! Please leave your email /messenger/whatsapp below",
      option:[
        {value:"", type:'text', label:"Please input email/messenger/whatsapp"},
      ],
      request:false,
      multiple:false
    }  
  ]

  function init(){
    make_question()
    $('.buttons .prev').click(function(){move_question(-1)})
    $('.buttons .next').click(function(){move_question()})
    $('.buttons .submit').click(function(){save_data()})
  }
  async function make_question(){
    let msg =""
    if(question_index>1 && question_index<9){
      msg = answer_data.q0[0] < 7 ? "sorry to hear that, where could we improve?" : "what do you love about us?"
    }
    $(".email_survey_2023>h4").text(msg)
    $('.email_survey_2023 .item .message').text('')

    const current_data = question_data[question_index]
    const question = `${question_index+1}. ${current_data['question']}`
    const answer_index = `q${question_index}`
    const current_answer = answer_data[answer_index] ?  answer_data[answer_index] : []
    const animationTime = 200

    $(".email_survey_2023 .item.container").fadeOut(animationTime)
    await MB_sleep(animationTime)

    $(".email_survey_2023 .item.container").attr('index', question_index)
    $(".email_survey_2023 .item.container .question").text(question)
    
    $(".email_survey_2023 .item.container .tips").hide()
    $(`.email_survey_2023 .item.container .tips.q${question_index}`).show()

    $(".email_survey_2023 .item.container .option").html("")

    for(i of current_data['option']){
      if(i.type=="select"){
        if(question_index==1 && answer_data.q0[0]<7 && i.value>5){
          continue
        }
        if(question_index==1 && answer_data.q0[0]>=7 && i.value<=5){
          continue
        }
        let classname = ""
        if(current_answer.indexOf(i.value)>-1){
          classname +="is_select "
        }
        const html = `<button value="${i.value}" class=${classname}>${i.label}</button>`
        $(".email_survey_2023 .item.container .option").append(html)
      }else if(i.type=='text'){
        if(i.id){
          const id =i.id
          const reg = new RegExp(`${id}:`)
          const item = current_answer.find(o=>reg.test(o))
          const value = item ? item.split(":")[1] : ""
          $(".email_survey_2023 .item.container .option").append(`<input id="q_${question_index}_a_${i.id}" vid="${i.id}" value="${value}" placeholder="${i.label}">`)
        }else{
          const text = current_answer.filter(o=>typeof(o)!="number").join()
          $(".email_survey_2023 .item.container .option").append(`<input value="${text}" placeholder="${i.label}">`)
        }
      }
    }

    // 个另题目特殊处理
    $(".email_survey_2023 .item.container .option").removeAttr('fill_size')
    if(question_index==4 && current_answer.length > 1 && current_answer[0]>0){
      $(".email_survey_2023 .item.container .option").attr('fill_size',1)
    }

    // 第2题多选显示
    if(question_index==1){
      $('.email_survey_2023 .message').text('Please select one or more option!!')
    }

    // button点击响应
    $(".email_survey_2023 .item.container .option button").click(function(){
      const value = $(this).val()
      // const answer_index = `q${question_index}`
      // answer_data[answer_index] = value
      
      if(!current_data.multiple){
        $(this).parent().find('button').removeClass('is_select')
      }
      $(this).toggleClass('is_select')

      // 增加尺寸填写框
      $(".email_survey_2023 .item.container .option").removeAttr('fill_size')
      if(question_index==4){
        if(value>0){
          // $(".email_survey_2023 .item.container .option input").slideDown(300)
          $(".email_survey_2023 .item.container .option").attr('fill_size',1)
        }else{
          // $(".email_survey_2023 .item.container .option input").slideUp(200)
        }
      }
    })


    if(question_index >= (question_data.length-1)){
      // $(".email_survey_2023 .buttons .next").hide()
      $(".email_survey_2023 .buttons .submit").show()
    }

    $(".email_survey_2023 .item.container").fadeIn(animationTime)

    if(question_index<1){
      $(".email_survey_2023 .buttons .prev").hide()
    }else{
      $(".email_survey_2023 .buttons .prev").show()
    }
  }

  function move_question(dir=1){
    const changed = (dir<0 && question_index>0) || dir>0 && question_index<(question_data.length)
    changed && save_answer(dir)
  }

  function save_answer(dir){
    const q_data = question_data[question_index]
    const select_option = []

    $('.email_survey_2023 .item.container button.is_select').each(function(){
      select_option.push(Number($(this).val()))
    })
    $('.email_survey_2023 .item.container input').each(function(){
      if($(this).val()){
        const vid = $(this).attr('vid')
        const value = vid ? `${vid}:${$(this).val()}` : $(this).val()
        select_option.push(value)
      }
    })

    if(q_data.request && !select_option.length){
      $('.email_survey_2023 .message').text('Please select one or more option!!')
      return false
    }

    const answer_index = `q${question_index}`
    answer_data[answer_index] = select_option
    // console.log(answer_data)
    
    question_index += dir
    
    if(question_index>=(question_data.length)){
      $(".email_survey_2023 .item").slideUp(200)
      $(".email_survey_2023 .buttons").slideUp(200)
      $(".email_survey_2023 .finish").css('display','flex')
      save_data()
    }else{
      make_question()
    }
  }
  function save_data(){
    const url_parms_customer_email = MB_getUrlParam('customer_email')
    let data = {
      answer:[],
      group_id:1,
    }
    if(customer_email || url_parms_customer_email){
      data.customer_email = url_parms_customer_email ? url_parms_customer_email : customer_email
    }
    if(customer_id){
      data.customer_id = customer_id
    }

    for(i in question_data){
      const q_data = question_data[i]
      const a_data = answer_data[`q${i}`]
      // console.log(q_data, a_data)
      if(a_data && a_data.length>0){
        data.answer.push({id:q_data.id, data:a_data})
      }

      // if(q_data.request && (!a_data || a_data.length==0)){
        // console.log(`No ${i+1  } is request!!`)
      // }

    }
    const url = 'https://www.ogl-datadriven.com/do/api/survey/submit'
    console.log(data)
    $.ajax({
      type: "POST",
      url,
      data,
      dataType: "json",
      crossDomain: true,
      success: function(data) {
          console.log(data);
      }
    });
  }

  MB_jsDeferHandle(init, ['jQuery'])

}) ()
